"use client"; // Ensure this is a Client Component

import WhatsAppButton from "@/components/WhatsAppButton";

const WhatsAppProvider = () => {
  return <WhatsAppButton />;
};

export default WhatsAppProvider;
